export default class CognitoRole {
  roleId: string;
  roleDescription: string;
  id?: number;

  constructor(roleId: string, roleDescription: string) {
    this.roleId = roleId;
    this.roleDescription = roleDescription;
  }
}



// WEBPACK FOOTER //
// ./src/models/company-resources/cognito-role.ts